import { SnLonLat } from '@lib/geo/helpers';

export function toGoogleMapLatLng(lonLat: SnLonLat): google.maps.LatLng {
  return new google.maps.LatLng(lonLat?.lat, lonLat?.lon);
}

export function fromGoogleMapLatLng(latLng: google.maps.LatLng): SnLonLat {
  return new SnLonLat(latLng?.lng(), latLng?.lat());
}
